import React, { useContext, useEffect, useState } from "react";
import NowDataMap from "../../../../NowDataMap";
import DeclareContext from "../../../../../ContextServer/DeclareContext";
import DataContext from "../../../../../ContextServer/DataContext";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import { Box, Button, Grid, MenuItem, styled } from "@mui/material";
import { BiSolidError } from "react-icons/bi";

// 텍스트 필드, 메뉴아이템 커스터마이징
function DeclareAnswer() {
  const { checkList, answerList, num, setNum } = useContext(DataContext);

  const navigate = useNavigate();

  let list = [];
  for (let i = 0; i < checkList.length; i++) {
    if (checkList[i].seqno === num) {
      list.push(checkList[i]);
    }
  }
  console.log(checkList);
  console.log(list);
  console.log(num);

  if (checkList.length === 0) {
    return (
      <div>
        <div className="declarelist-container">
          <div className="declarelist-box">
            <div className="declarelist-contents">
              <BiSolidError fontSize={30} />

              <p>휴대폰번호 혹은 비밀번호가 맞지 않습니다.</p>
              <Button
                onClick={() => {
                  navigate("/odor/declarelist");
                }}
              >
                재확인 필요
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  } else if (list[0]?.seqno !== num) {
    return (
      <div className="declarelist-container">
        <div className="declarelist-box">
          <div className="declarelist-contents">
            <BiSolidError fontSize={30} />

            <p>작성하신 게시물이 아닙니다.</p>
            <small>다시 확인 부탁드립니다.</small>
            <Button
              onClick={() => {
                navigate("/odor/declarelist");
              }}
            >
              재확인 필요
            </Button>
          </div>
        </div>
      </div>
    );
  }

  if (checkList.length > 0) {
    const renderGridItem = (label, value) => (
      <Grid item xs={12} sm={12}>
        {value && (
          <>
            <label>{label}</label>
            <TextField required fullWidth value={value} multiline rows={5} />
            <p style={{ color: "red" }}>* 조치결과는 수정할 수 없습니다.</p>
          </>
        )}
      </Grid>
    );

    return (
      <div className="declarelist-container">
        <div className="declarelist-box">
          <div className="declarelist-contents">
            <div className="declareTitle">
              <h2>악취신고 내역</h2>
            </div>

            <div className="map-container">
              <NowDataMap />
            </div>

            <h3 style={{ textAlign: "left" }}>
              신고일시 : {list[0]?.datetime}
            </h3>

            <Grid
              container
              spacing={2}
              sx={{ marginTop: 2, textAlign: "left" }}
            >
              <Grid item xs={12} sm={12}>
                <label>
                  주소* <small>(필수)</small>
                </label>
                <TextField
                  required
                  fullWidth
                  value={list[0]?.report_addr}
                  autoComplete="given-name"
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <label>
                  악취강도* <small>(필수)</small>
                </label>
                <TextField
                  required
                  fullWidth
                  value={list[0]?.stink_levelnm}
                  autoComplete="given-name"
                  sx={{ backgroundColor: "orange" }}
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <label>
                  악취종류* <small>(필수)</small>
                </label>
                <TextField
                  required
                  fullWidth
                  value={list[0]?.stink_div}
                  autoComplete="given-name"
                  sx={{ backgroundColor: "orange" }}
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <label>
                  추가 요청내용* <small>(선택)</small>
                </label>
                <TextField
                  required
                  fullWidth
                  value={list[0]?.bigo}
                  autoComplete="given-name"
                  multiline
                  rows={5}
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                {list[0]?.report_reply1 && (
                  <>
                    <label>조치결과</label>
                    <TextField
                      required
                      fullWidth
                      value={list[0]?.report_reply1}
                      multiline
                      rows={5}
                    />
                    <p style={{ color: "red" }}>
                      * 조치결과는 수정할 수 없습니다.
                    </p>
                  </>
                )}
              </Grid>
              {renderGridItem("조치결과2", list[0]?.report_reply2)}
              {renderGridItem("조치결과3", list[0]?.report_reply3)}

              <Grid item xs={12} sm={6}>
                <label>
                  작성자* <small>(필수)</small>
                </label>
                <TextField
                  required
                  fullWidth
                  value={list[0]?.report_nm}
                  autoComplete="given-name"
                  size={"small"}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <label>
                  번호* <small>(필수)</small>
                </label>
                <TextField
                  required
                  fullWidth
                  value={list[0]?.report_mob_num}
                  autoComplete="given-name"
                  size={"small"}
                />
              </Grid>
            </Grid>

            <Box sx={{ marginTop: 2, height: "2vh" }}>
              <Button
                sx={{ float: "right" }}
                variant="contained"
                color={"inherit"}
                onClick={() => {
                  navigate("/odor/declarelist");
                }}
              >
                목록으로
              </Button>
            </Box>
          </div>
        </div>
      </div>
    );
  }
}

export default DeclareAnswer;
